export default {
  SET({commit}, payload) {
    commit('SET', payload)
  },
  RESET({commit}, payload) {
    commit('RESET', payload)
  },
};